const AppConfig = {
  api: {
    url: 'https://api.minhngocstar.com/'
  }
}

export default AppConfig;
